import { render, staticRenderFns } from "./ProjectCardStatus.vue?vue&type=template&id=2f664023&scoped=true&"
import script from "./ProjectCardStatus.vue?vue&type=script&lang=js&"
export * from "./ProjectCardStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardStatus.vue?vue&type=style&index=0&id=2f664023&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f664023",
  null
  
)

export default component.exports